<script lang="ts" setup>
const props = defineProps({
  title: {
    type: String,
    default: '',
  },

  small: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div class="info-card box-border pt-24px">
    <div class="info-card__inner relative box-border h-full rounded-4px bg-white px-32px" :class="[$slots.title || props.title ? 'pt-40px' : 'pt-32px', props.small ? 'pb-24px' : 'pb-32px']">
      <div class="info-card__title" v-if="$slots.title">
        <slot name="title"></slot>
      </div>
      <h3 class="info-card__title" v-else-if="props.title">
        {{ props.title }}
      </h3>
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.info-card {
  .info-card__inner {
    border: 1px solid rgba(154, 158, 166, 0.1);
    box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.08);

    .info-card__title {
      @apply absolute left-50% top-0 m-0 h-48px min-w-192px rounded-2px bg-brand-primary px-32 text-center text-16px font-normal leading-48px text-white -translate-50% box-border whitespace-nowrap;

      > :deep(*) {
        @apply m-0 c-inherit font-inherit w-full h-full text-size-inherit box-border;
      }
    }
  }
}
</style>
